module.exports = __webpack_public_path__ + "img/Y5.a4987f53.png";